import apiClient from "./apiClient";

// DAS-182: 업비트 코인빌리기(담보·대여) 잔차 추정 조회/보정 API

export const fetchLoan = (username) =>
    apiClient.get(`/api/loan/${username}`);

// CRITICAL-2 리뷰 반영: 구조분해로 필드를 골라 보내면 collateral_coins·collateral_avg_price 등
// 신규 필드가 조용히 탈락한다 — PUT은 전체 교체이므로 호출자가 만든 payload를 그대로 전달한다.
export const updateLoan = (username, payload) =>
    apiClient.put(`/api/loan/${username}`, payload);

export const resetLoan = (username) =>
    apiClient.delete(`/api/loan/${username}`);
